import { PropsWithChildren } from "react";
import { Learner } from "../../types";
import Button from "../../../student/components/generic/button";
import { REACT_APP_LEARNER_LINK } from "../../../utils";

export const InviteError: React.FC<
  PropsWithChildren<{ errorCode: string }>
> = ({ errorCode, children }) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const learner: Learner | undefined = user?.entitlements ? user : undefined;
  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-col gap-4 text-center font-serif font-bold text-dm-brand-blue-600">
        <i className="far fa-exclamation-triangle text-3xl text-dm-error-500" />
        <h1 className="text-2xl">
          Looks Like There&apos;s
          <br />a Problem
        </h1>
        <h2>Error {errorCode}</h2>
      </header>
      <div className="flex flex-col gap-4 text-center text-dm-brand-blue-800">
        <p>{children}</p>
      </div>
      {learner && (
        <Button
          className="mt-2"
          href={`${REACT_APP_LEARNER_LINK}/common/profile`}
        >
          Go to Dashboard
        </Button>
      )}
    </div>
  );
};
